import { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useTranslation } from "react-i18next";
import AssignedAssessmentsListRowButtons from "./AssignedAssessmentsListRowButtons";

const AssignedAssessmentApplicationRow = ({
  lastItem,
  application,
  applicationResult,
  appIdString,
  isPastDeadline,
}) => {
  const { t } = useTranslation();
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    if (isCopied) {
      const timer = setTimeout(() => setIsCopied(false), 600);
      return () => clearTimeout(timer);
    }
  }, [isCopied]);

  const handleCopyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => setIsCopied(true))
      .catch((err) => console.error("Failed to copy: ", err));
  };

  return (
    <Row
      className="justify-content-between py-2"
      style={{
        borderBottom: `2px solid ${lastItem ? "transparent" : "#e7ecef"}`,
        marginRight: "-5px",
      }}
    >
      <Col xs="auto" md={6} className="text-18 text-color-gray-light fw-medium align-content-center">
        <Row>
          <Col xs="auto">{application.applicationName}</Col>
        </Row>
      </Col>

      <Col xs="auto" className="align-content-center  text-color-gray-light fw-medium">
        <div
          className="text-12 position-relative"
          style={{ cursor: "pointer" }}
          onClick={() => handleCopyToClipboard(appIdString)}
          title={t("clickToCopyTooltip")}
        >
          {appIdString}{" "}
          {isCopied && (
            <div className="position-absolute w-100 text-center justify-content-center animate__animated animate__fadeOutDown">
              {t("copiedLabel")}
            </div>
          )}
        </div>
      </Col>

      <Col xs={12} md="auto" className="align-content-center ms-auto mt-3 mt-md-0">
        {!applicationResult && !isPastDeadline ? (
          <Row className="mx-0 text-12 text-color-gray-light fw-medium justify-content-center">
            <Col xs="auto">{t("notStartedLabel")}</Col>
          </Row>
        ) : applicationResult?.isFinished ? (
          <AssignedAssessmentsListRowButtons
            type={applicationResult.applicationType}
            result={applicationResult}
            applicationName={application.applicationName}
            color="#8B8C89"
            size={35}
          />
        ) : applicationResult?.sessions[4]?.endDate ? (
          <Row className="mx-0 text-12 text-color-gray-light fw-medium justify-content-center">
            <Col xs="auto">{t("noAttemptsLeft")}</Col>
          </Row>
        ) : isPastDeadline ? (
          <Row className="mx-0 text-12 text-color-gray-light fw-medium justify-content-center">
            <Col xs="auto">{t("deadlinePassed")}</Col>
          </Row>
        ) : (
          <Row className="mx-0 text-12 text-color-gray-light fw-medium justify-content-center">
            <Col xs="auto">{t("inProgressLabel")}</Col>
          </Row>
        )}
      </Col>
    </Row>
  );
};

export default AssignedAssessmentApplicationRow;
